import { toLocalISODate } from './selfiePeriod';

/**
 * Dias restantes até ao fim do ciclo (inclusive).
 * @returns {number|null}
 */
export function cycleDaysRemaining(cycle, referenceDate = new Date()) {
  if (!cycle?.end) return null;

  const todayIso = toLocalISODate(referenceDate);
  if (todayIso > cycle.end) return 0;

  const today = new Date(`${todayIso}T12:00:00`);
  const end = new Date(`${cycle.end}T12:00:00`);
  const diffMs = end.getTime() - today.getTime();
  return Math.floor(diffMs / (24 * 60 * 60 * 1000)) + 1;
}

/**
 * Dia actual dentro do ciclo (1 = primeiro dia).
 * @returns {number|null}
 */
export function cycleDayNumber(cycle, referenceDate = new Date()) {
  if (!cycle?.start) return null;

  const todayIso = toLocalISODate(referenceDate);
  const start = new Date(`${cycle.start}T12:00:00`);
  const today = new Date(`${todayIso}T12:00:00`);
  if (today < start) return 1;

  const diffMs = today.getTime() - start.getTime();
  return Math.floor(diffMs / (24 * 60 * 60 * 1000)) + 1;
}

/**
 * Duração do ciclo em dias (inclusive).
 * @returns {number|null}
 */
export function cycleTotalDays(cycle) {
  if (!cycle?.start || !cycle?.end) return null;
  const start = new Date(`${cycle.start}T12:00:00`);
  const end = new Date(`${cycle.end}T12:00:00`);
  const diffMs = end.getTime() - start.getTime();
  return Math.floor(diffMs / (24 * 60 * 60 * 1000)) + 1;
}
